import { render, staticRenderFns } from "./campaign-preview.vue?vue&type=template&id=1374c37e"
import script from "./campaign-preview.vue?vue&type=script&lang=js"
export * from "./campaign-preview.vue?vue&type=script&lang=js"
import style0 from "./campaign-preview.vue?vue&type=style&index=0&id=1374c37e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports